export default {
  EBWC_WIN: 0,
  EBWC_BIG_WIN: 10,
  EBWC_MEGA_WIN: 20,
  EBWC_EPIC_WIN: 30,
}
